export default "__VITE_ASSET__CLjv_MYW__"